<template>
  <div class="main-container bg-white">
    <HeaderPickup
      class="hidden lg:block lg:mx-auto lg:w-11/12"
      title="Completar formulario"
      subtitle="Seleccione formulario a completar"
    />
    <div
      class="block lg:hidden fixed top-0 z-20 text-white bg-zt-primary-200 flex w-full document--header items-center px-6"
    >
      <button
        class="mr-auto md:pl-4 text-zt-xl"
        @click="$router.replace({ name: 'upload' })"
        data-vs-button="replace-upload"
      >
        <zt-icon name="angle-left" />
      </button>
      <p class="w-full text-center text-zt-lg">
        {{ $t('message.UploadLanding.pickup.title') }}
      </p>
    </div>
    <div v-if="!loading">
      <div class="w-11/12 mx-auto md:mx-5 pt-4 pb-5">
        <div class="w-full md:w-9/12 md:mt-4">
          <div class="">
            <v-text-field
              flat
              label
              prepend-inner-icon="search"
              v-model="inputValue"
              clearable
              @click:clear="clearSearch"
              class="w-11/12 mx-auto md:float-left md:w-1/4"
              data-vs-input="input-search"
            ></v-text-field>
          </div>
        </div>
        <div v-if="filteredEforms.length > 0">
          <zt-list-item
            v-for="(eform, index) in filteredEforms"
            :key="eform.id"
            :title="eform.nombre"
            class="mt-2 list-hover"
            @click="createNewEform(eform)"
            :data-vs-button="`list-item-${index}`"
          >
            <template slot="icon">
              <zt-icon name="file" class="custom-file-icon" />
            </template>
          </zt-list-item>
        </div>
        <EmptyState v-else />
      </div>
    </div>
    <div v-else class="mt-20">
      <vue-loading
        v-if="loading"
        background-color="rgba(0,0,0,0.0)"
        :active="loading"
        color="#4F41A3"
        :is-full-page="false"
      />
    </div>
  </div>
</template>

<script>
import PickUp from '@/apiClient/PickUp'
import { mutations } from '../store'
import { filter, includes } from 'lodash'
import HeaderPickup from './HeaderPickup'
import EmptyState from './EmptyState'

export default {
  name: 'CreatePickUp',
  components: {
    HeaderPickup,
    EmptyState
  },
  data() {
    return {
      PickUp: '',
      eforms: [],
      inputValue: '',
      loading: false
    }
  },
  created() {
    this.loading = !this.loading
    this.PickUp = new PickUp()
    this.PickUp.getEforms()
      .then(res => {
        const {
          results: { data }
        } = res.data
        this.eforms = data
        this.loading = !this.loading
      })
      .catch(() => {
        this.loading = !this.loading
      })
  },

  computed: {
    filteredEforms() {
      if (this.inputValue) {
        return filter(this.eforms, eform => {
          return includes(
            eform.nombre.toLowerCase(),
            this.inputValue.toLowerCase()
          )
        })
      }

      return this.eforms
    }
  },

  methods: {
    async createNewEform(eform) {
      this.loading = !this.loading
      const {
        data: { hash }
      } = await this.PickUp.createEform(eform.id)
      if (hash) {
        mutations.setHashEform(hash)
        mutations.setEformSelected(eform)
        this.$router.push({ name: 'pickup-detail' })
      }
      this.loading = !this.loading
    },
    clearSearch() {
      this.inputValue = ''
    }
  }
}
</script>

<style scoped>
.outline-none {
  outline: none;
}

.main-container {
  height: 100%;
}

.main--selection {
  margin-bottom: 12px;
  padding-left: 40px;
  padding-top: 10px;
}

.main--filter {
  width: 188px;
  display: flex;
  padding: 2px;
  border: 1px solid white;
}

.main--filter__active {
  border-radius: 4px;
  border-color: #e0e0e0;
}

.main--input {
  width: 100%;
}

.main--input:focus {
  outline: none;
}

.main-list {
  max-height: calc(100vh - 181px);
  overflow-y: auto;
  padding-left: 40px;
}

.document--header {
  height: 64px;
}

.list-hover:hover {
  background-color: #f5f5f5;
}

.custom-file-icon {
  font-size: 2.5rem;
  align-self: center;
  color: #6f6f6f;
}
</style>
